// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"21":"3f90327eaabb0d96f031","57":"01995cd5cb77bfa6c307","60":"9b76d68e2dd9fca9d68a","121":"dc6a50a50613de5b1f35","599":"6c07fcbd9f2f9b089cce","818":"0fc86948857171544a4a","985":"cec7f071d59a2fcde237"}[chunkId] + ".js";
};